export default __webpack_public_path__ + "static/media/logo.d1ad8b69.png";